import { get } from '@alltrails/shared/api';

export default async function getElevationProfile(mapId: number) {
  return get<{ smoothedElevations?: { index: number; elevation: number }[] }>(`/api/alltrails/v3/maps/${mapId}/elevation_profile`);
}
